import { ReactNode } from "react"
import { cn } from "@ui/utils"
import { Sparkles } from "lucide-react"

interface SummaryNotationProps {
  aiNotice?: string | null
  children?: ReactNode
  className?: string
}

export function SummaryNotation({ aiNotice, children, className }: SummaryNotationProps) {
  if (!aiNotice && !children) return null

  return (
    <div className={cn("text-muted-foreground mt-3 space-y-1 border-t pt-2 text-xs", className)}>
      {aiNotice && (
        <p className="flex items-start gap-1.5">
          <Sparkles className="mt-0.5 size-3.5 shrink-0" aria-hidden />
          <span>{aiNotice}</span>
        </p>
      )}
      {children}
    </div>
  )
}
